import React from "react";
import { useState } from "react";
import Select from "react-select";
import countryList from "react-select-country-list";
import { useMemo } from "react";
import Country from "../../components/common/country";

const EditDistributors = () => {

      const options = useMemo(() => countryList().getData(), []);
    const [value, setvalue] = useState(null);
  const [imagePreview, setImagePreview] = useState();

  const readURL = (input) => {
    if (input.files && input.files[0]) {
      const reader = new FileReader();
      reader.onload = function (e) {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(input.files[0]);
    }
  };
    const [companyName, setCompanyName] = useState("");
    const [isCustomCompany, setIsCustomCompany] = useState(false);
    const [email, setEmail] = useState("");
    const [isCustomEmail, setIsCustomEmail] = useState(false);
    const [website, setWebsite] = useState("");
    const [isCustomWebsite, setIsCustomWebsite] = useState(false);
   
  return (
    <>
      <div className="body">
        <div className="inputFields">
          <div className="distributors">
            <form action="">
              <div className="form-headerr">
                <div className="image-upload-section">
                    <h4>Upload Logo</h4>
                  <div className="avatar-upload" style={{ margin: "0" }}>
                    <div className="avatar-edit">
                      <input
                        type="file"
                        id="imageUpload"
                        accept=".png, .jpg, .jpeg"
                        onChange={(e) => readURL(e.target)}
                      />
                      <label htmlFor="imageUpload"></label>
                    </div>
                    <div className="avatar-preview">
                      <div
                        id="imagePreview"
                        style={{ backgroundImage: `url(${imagePreview})` }}
                      ></div>
                    </div>
                  </div>
                </div>
                <div className="name">
                  <label htmlFor="">Company Name</label>
                  <select
                    value={isCustomCompany ? "custom" : companyName}
                    onChange={(e) => {
                      if (e.target.value === "custom") {
                        setIsCustomCompany(true);
                        setCompanyName("");
                      } else {
                        setIsCustomCompany(false);
                        setCompanyName(e.target.value);
                      }
                    }}
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      padding: "15px",
                      borderRadius: "20px",
                      border: "none",
                      display: isCustomCompany ? "none" : "block",
                    }}
                  >
                    <option value="">Company Name...</option>
                    {/* {companyOptions.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))} */}
                    <option value="custom">Other (Type custom)</option>
                  </select>
                  {isCustomCompany && (
                    <div style={{ position: "relative", marginTop: "10px" }}>
                      <input
                        type="text"
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                        placeholder="Text here..."
                        style={{
                          width: "100%",
                          padding: "15px",
                          borderRadius: "20px",
                          border: "none",
                          backgroundColor: "#ffffffff",
                          fontSize: "14px",
                          outline: "none",
                        }}
                      />
                      <button
                        type="button"
                        onClick={() => {
                          setIsCustomCompany(false);
                          setCompanyName([0]);
                        }}
                        style={{
                          marginTop: "5px",
                              padding: "8px",
                              fontSize: "12px",
                              cursor: "pointer",
                              borderRadius: "20px",
                              background: "#004996",
                              color: "#fff",
                              border: "none",
                        }}
                      >
                        Back to dropdown
                      </button>
                    </div>
                  )}
                </div>
                <div className="name">
                  <label htmlFor="" className="label">
                    Email
                  </label>
                  <select
                    value={isCustomEmail ? "custom" : email}
                    onChange={(e) => {
                      if (e.target.value === "custom") {
                        setIsCustomEmail(true);
                        setEmail("");
                      } else {
                        setIsCustomEmail(false);
                        setEmail(e.target.value);
                      }
                    }}
                    style={{
                      width: "100%",
                      padding: "15px",
                      marginTop: "10px",
                      borderRadius: "20px",
                      border: "none",
                      display: isCustomEmail ? "none" : "block",
                    }}
                  >
                    <option value="">Email...</option>
                    {/* {emailOptions.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))} */}
                    <option value="custom">Other (Type custom)</option>
                  </select>
                  {isCustomEmail && (
                    <div style={{ position: "relative", marginTop: "10px" }}>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Text here..."
                        style={{
                          width: "100%",
                          borderRadius: "20px",
                          border: "none",
                          backgroundColor: "#ffffffff",
                          fontSize: "14px",
                          outline: "none",
                        }}
                      />
                      <button
                        type="button"
                        onClick={() => {
                          setIsCustomEmail(false);
                          setEmail([0]);
                        }}
                        style={{
                          marginTop: "5px",
                              padding: "8px",
                              fontSize: "12px",
                              cursor: "pointer",
                              borderRadius: "20px",
                              background: "#004996",
                              color: "#fff",
                              border: "none",
                        }}
                      >
                        Back to dropdown
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="formContact">
                <div className="name">
                  <label htmlFor="" className="description">
                    Website
                  </label>
                  <br />
                  <select
                    value={isCustomWebsite ? "custom" : website}
                    onChange={(e) => {
                      if (e.target.value === "custom") {
                        setIsCustomWebsite(true);
                        setWebsite("");
                      } else {
                        setIsCustomWebsite(false);
                        setWebsite(e.target.value);
                      }
                    }}
                    style={{
                      width: "100%",
                      marginTop: "10px",
                      padding: "15px",
                      borderRadius: "20px",
                      border: "none",
                      display: isCustomWebsite ? "none" : "block",
                    }}
                  >
                    <option value="">Website...</option>
                    {/* {phoneOptions.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))} */}
                    <option value="custom">Other (Type custom)</option>
                  </select>
                  {isCustomWebsite && (
                    <div style={{ position: "relative", marginTop: "10px" }}>
                      <input
                        type="text"
                        value={website}
                        onChange={(e) => setWebsite(e.target.value)}
                        placeholder="Text here..."
                        style={{
                          width: "100%",
                          padding: "15px",
                          borderRadius: "20px",
                          border: "none",
                          backgroundColor: "#f5f5f5",
                          fontSize: "14px",
                          outline: "none",
                        }}
                      />
                      <button
                        type="button"
                        onClick={() => {
                          setIsCustomWebsite(false);
                          setWebsite("");
                        }}
                        style={{
                           marginTop: "5px",
                              padding: "8px",
                              fontSize: "12px",
                              cursor: "pointer",
                              borderRadius: "20px",
                              background: "#004996",
                              color: "#fff",
                              border: "none",
                        }}
                      >
                        Back to dropdown
                      </button>
                    </div>
                  )}
                </div>

                <Country />

                
                <div className="container">
                  <label htmlFor="">Status</label>
                  <div className="radioBtns">
                  <div className="radio">
                    <input id="radio-1" name="radio" type="radio" />
                    <label htmlFor="radio-1" className="radio-label">
                      Active
                    </label>
                  </div>

                  <div className="radio">
                    <input id="radio-2" name="radio" type="radio" />
                    <label htmlFor="radio-2" className="radio-label">
                      Inactive
                    </label>
                  </div>
                  </div>
                </div>
              </div>
              <button
                className="commonButton" style={{marginLeft:'auto'}}
                onClick={() =>
                  (window.location.href = "/distributors/DistributorsList")
                }
              >
                Update
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditDistributors;
